import React from 'react';
import { CHECKOUT_URL, PRODUCT_NAME, readyBlockItems, searchBlockItems } from '../data/atlante';
export function SearchSection() {
  return <section className="bg-ivory px-4 py-5 sm:py-7" data-id="element-162" data-mp="13qam6dr38q1a">
      <div className="mx-auto grid max-w-5xl gap-3 md:grid-cols-2" data-id="element-163" data-mp="pxkpnfdxo2px">
        <a href={CHECKOUT_URL} className="flex flex-col border-l-4 border-navy bg-white p-4 shadow-sm transition-colors duration-150 hover:bg-mist/30" data-id="element-164" data-mp="uvvzhq48ad85">
          <h2 className="text-base leading-tight text-navy sm:text-lg" data-id="element-165" data-mp="1ijcj84dfgznh">
            😩 SMETTI DI CERCARE OGNI VOLTA TRA RISORSE DIVERSE
          </h2>
          <p className="mt-1.5 text-[13px] font-medium leading-snug text-slate2" data-id="element-166" data-mp="18m7r7nwwi9yr">
            Il tuo tempo dovrebbe essere dedicato alla professione — non a cercare
            immagini, confrontare riferimenti e organizzare informazioni sparse.
          </p>
          <p className="mt-1.5 text-[13px] font-bold leading-snug text-navy" data-id="element-167" data-mp="277487put24b">
            {PRODUCT_NAME} raccoglie le risorse per te.
          </p>
          <ul className="mt-2 grid gap-0.5 sm:grid-cols-2" data-id="element-168" data-mp="3pnjm93r57n6h">
            {searchBlockItems.map(item => <li key={item} className="text-[12.5px] font-semibold leading-snug text-navy" data-id="element-169" data-mp="3lmrc88ag5e95">
                <span className="text-gold" data-id="element-170" data-mp="3uluvbc9m5tnn">▸</span> {item}
              </li>)}
          </ul>
          <p className="mt-2 text-[13px] font-medium leading-snug text-slate2" data-id="element-171" data-mp="cg8ckn115ff0">
            Tutto è organizzato per permetterti di individuare il riferimento
            pertinente, confrontare le alternative, osservare i dettagli e
            consultare il materiale utilizzando la tua esperienza professionale.
          </p>
          <p className="mt-auto pt-2 font-display text-sm font-extrabold uppercase tracking-wide text-green" data-id="element-172" data-mp="h6ow8ovg1x9t">
            Meno ricerca. Più riferimenti visuali.
          </p>
        </a>

        <a href={CHECKOUT_URL} className="flex flex-col border-l-4 border-gold bg-white p-4 shadow-sm transition-colors duration-150 hover:bg-mist/30" data-id="element-173" data-mp="r5o25zotret4">
          <h2 className="text-base leading-tight text-navy sm:text-lg" data-id="element-174" data-mp="137fey78k1ki0">
            ⏱️ MENO RICERCA. PIÙ RISORSE PRONTE DA CONSULTARE.
          </h2>
          <ul className="mt-2 space-y-1" data-id="element-175" data-mp="184xnvxmknzq0">
            {readyBlockItems.map(item => <li key={item} className="text-[13px] font-semibold leading-snug text-navy" data-id="element-176" data-mp="1cy0kkemnbpaf">
                <span className="text-gold" data-id="element-177" data-mp="1hyo8usjhps0y">▸</span> {item}
              </li>)}
          </ul>
          <p className="mt-auto pt-3 font-display text-sm font-extrabold uppercase tracking-wide text-green" data-id="element-178" data-mp="1lzrpvid9xu3r">
            Apri il sistema. Trova l’area. Consulta il riferimento. Analizza.
          </p>
        </a>
      </div>
    </section>;
}